import { environment } from './environments/environment';
function pushGtmEvent(
  eventName: string,
  parameters: Record<string, unknown> = {}
): void {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: eventName,
    ...parameters
  });
  console.log(`[GTM] ${eventName}`, parameters);
}

function initializeLiveChatClickTracking(): void {
  document.addEventListener(
    'click',
    (event: MouseEvent) => {
      const eventPath = event.composedPath();

      const clickedLauncher = eventPath.some((element: EventTarget) => {
        if (!(element instanceof HTMLElement)) {
          return false;
        }

        return (
          element.tagName === 'LW-LAUNCHER-BUTTON' ||
          (
            element.tagName === 'BUTTON' &&
            element.classList.contains('btn')
          )
        );
      });

      if (!clickedLauncher) {
        return;
      }

      pushGtmEvent('livechat_click', {
        widget_name: 'LiveChat',
        page_path: window.location.pathname
      });
    },
    true
  );

  console.log('[LiveChat] Seguimiento de clic inicializado');
}

initializeLiveChatClickTracking();
// Set LiveChat configuration to window object
if (environment.liveChat) {
  window.LiveChatConfig = {
    liveChatToken: environment.liveChat.LiveChatToken,
    serverTss: environment.liveChat.serverTss,
    serverGateway: environment.liveChat.serverGateway,
    apiKey: environment.liveChat.apiKey,
    channelId: environment.liveChat.channelId,
    eventNameReceived: environment.liveChat.eventNameReceived,
    uuidKey: environment.liveChat.uuidKey
  };

  window.MyLivechat = {
    siteId: environment.liveChat.siteId,
  };

  // Dynamically load the LiveChat script
  if (environment.liveChat.loaderUrl) {
    const script = document.createElement('script');
    script.src = environment.liveChat.loaderUrl;
    script.async = true;
    script.onload = () => {
      pushGtmEvent('livechat_loaded', {
        widget_name: 'LiveChat',
        page_path: window.location.pathname
      });

      console.log('[LiveChat] Widget cargado');
    };

    script.onerror = () => {
      console.error('[LiveChat] No se pudo cargar el widget');
    };
    document.head.appendChild(script);
  }
}
export{};